import { take, fork } from 'typed-redux-saga'
import { Callback } from 'Src/types/utilTypes'
import { WorkerCache } from 'Src/helpers'

export const takeEveryUnique = (actionType: string, saga: Callback, ...args: unknown[]) =>
	fork(function* worker() {
		while (true) {
			const action = yield* take(actionType)
			const stringifyAction = JSON.stringify(action)

			if (!WorkerCache.hasCache(actionType, stringifyAction)) {
				WorkerCache.setCache(actionType, stringifyAction)
				yield* fork(saga, ...args.concat(action))
			}
		}
	})
